module.exports = __webpack_public_path__ + "static/img/18.fe3b5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/18.png
// module id = eDeF
// module chunks = 0